<template>
  <div>
    <v-card flat style="padding:16px;">
      <h3 style="text-align:left;margin-bottom:10px">カラログる食品、飲食店を検索</h3>
      <v-layout row wrap style="background:#fff;border-radius:2px;border: 1px solid #f44336;margin-bottom: 16px;">
        <v-flex xs9>
          <input  v-model="query.kwd"
          type="text" placeholder="食品名、飲食店名・場所など" style="height:50px;width:100%;padding:0 10px;">
        </v-flex>
          <v-flex xs3>
            <v-btn @click="onSearch"
              block color="primary" dark style="height:104%;position:relative;top:-7px;left:0px;"><v-icon>search</v-icon>検索</v-btn>
          </v-flex>
      </v-layout>
      <div v-if="isSearched && !loading" style="margin-bottom: 24px;">
        <v-layout row wrap v-for="(r, id) in rows" :key=id style="margin-bottom: 5px;">
          <!-- <v-flex xs12 @click="onReview(r.id)"> -->
          <v-flex xs12>
            <food-card-min
              v-if="r.type=='food'"
              :name="r.name"
              :imageurl="r.imageurls[0]"
              label="食品"
              mode="review"
              @onFoodCardMinClick="onReview(r.id)"
              ></food-card-min>
            <shop-card-min
              v-else-if="r.type=='shop'"
              :shop=r
              @click="onReview(r.id)"
            ></shop-card-min>
            <shop-google-card-min
              v-else-if="r.type=='google'"
              :shop=r
              @click="onReview(r.id)"
            ></shop-google-card-min>
          </v-flex>
        </v-layout>
        <v-flex v-show="isNotFound">
          <p>検索結果が0件です</p>
        </v-flex>
        <div v-if="mode=='entry'">
          <v-flex xs12 style="margin-top:24px;text-align:left;">
            思った食品がヒットしない場合、
          </v-flex>
          <v-btn large color="primary" dark block
            :to="{name: 'reviewPostViewWithFood', params: {mode: 'free'}, query: {maybe: this.query.kwd}}"
          >
            <v-icon>add</v-icon>新しく食品を登録してカラログる
          </v-btn>
        </div>
      </div>
      <div v-show="loading" style="text-align:center;margin:16px;">
        <v-progress-circular :size="40" :width="4" color="primary" indeterminate></v-progress-circular>
      </div>
    </v-card>
    <v-card v-if="mode=='entry'" flat style="margin-top: 24px; text-align:left;margin-bottom:10px;padding:16px;">
      <h3>食品を選択せずにカラログを投稿</h3>
      <v-flex xs12>
        <v-btn
        @click="onSelectNoFood"
        outline color="primary" block
        >食品を選択せずにカラログを投稿<v-icon>chevron_right</v-icon></v-btn>
      </v-flex>
    </v-card>
  </div>
</template>

<script>
import {functions} from '@/main' 
import FoodCardMin from '@/components/card/FoodCardMin.vue'
import ShopCardMin from '@/components/card/ShopCardMin.vue'
import ShopGoogleCardMin from '@/components/card/ShopGoogleCardMin.vue'
export default {
  name: 'ObjectSearch',
  props: {
    mode: {
      type: String,
      default: 'entry'
    }
  },
  data () {
    return {
      query: {
        kwd: ''
      },
      isLoading: false,
      isLoadingShops: false,
      isLoadingGoogle: false,
      isSearched: false,
      rows: []
    }
  },
  computed: {
    loading () {
      if (this.isLoading || this.isLoadingShops || this.isLoadingGoogle) return true
      return false
    },
    isNotFound () {
      if (this.isSearched && this.rows.length === 0) return true
      return false
    }
  },
  methods: {
    async onSearch () {
      if (this.isLoading || this.isLoadingShops) return
      this.rows = []
      this.doSearch()
      await this.doSearchShops()
      this.doSearchByGoogle()
    },
    async doSearch () {
      this.isLoading = true
      this.$store.commit('initFood')
      this.$store.commit('setFoodQueryKwd',this.query.kwd)
      this.$store.commit('setFoodQuery')
      let fs = []
      fs = await this.$store.dispatch('getFoodByQuery', true)
      fs.forEach(f => {
        f.type = 'food'
        this.rows.push(f)
      })
      this.isLoading = false
      this.isSearched = true
    },
    async doSearchShops () {
      if (this.query.kwd == '') return
      this.isLoadingShops = true
      this.$store.commit('initShops')
      this.$store.commit('setShopsQueryKwd',this.query.kwd)
      this.$store.commit('setShopsQuery')
      let fs = []
      fs = await this.$store.dispatch('getShopsByQuery', true)
      fs.forEach(f => {
        f.type = 'shop'
        this.rows.push(f)
      })
      this.isLoadingShops = false
      this.isSearched = true
    },
    async doSearchByGoogle () {
      if (this.query.kwd == '') return
      this.isLoadingGoogle = true
      let api = functions.httpsCallable('apiPlaceByKwd')
      api({kwd: this.query.kwd}).then((result) => {
        let shops = result.data.data.candidates
        let counter = 0
        shops.forEach(s => {
          s.type = 'google'
          s.id = `google_temp_${counter}`
          counter++
          if (!this.isPlaceDuplicated(s)) {
            this.rows.push(s)
          }
        })
        this.isLoadingGoogle = false
        this.isSearched = true
      })
    },
    // すでにカライイネのDBに登録済の場合か判定する
    isPlaceDuplicated (googlePlaceObj) {
      let checkId = googlePlaceObj.place_id
      for (let i = 0; i < this.rows.length; i++) {
        let s = this.rows[i]
        if (s.type === 'shop') {
          let placeId = s.system.ID.placeID
          if (placeId === checkId) {
            return true
          }
        }
      }
      return false
    },
    onReview (id) {
      let food = this.rows.find(f => f.id === id)
      this.$store.commit('setTempId', food.id)
      this.$store.commit('setTempFoodData', food)
      this.$store.commit('setTempImages', food.imageurls)
      this.$emit('onSelect', food.type)
    },
    onSelectNoFood () {
      this.$emit('onSelectNoFood')
    }
  },
  components: {
    FoodCardMin,
    ShopCardMin,
    ShopGoogleCardMin
  }
}
</script>

<style scoped>
</style>